const MateriaisSection = ({ materiais }) => (
  <section className="materiaisSection">
      <h2>Lista de Materiais</h2>
      <p className="materiaisSubtitle">
        Acesse abaixo as listas de materiais em PDF.
      </p>

      <div className="materiaisGrid">
        {materiais.map((item) => (
        <a
          key={item.ano}
          href={item.pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="materialCard"
        >
        <div className="materialHeader">
          <span className="materialAno">{item.ano}</span>
          <span className="materialPdf">PDF</span>
        </div>
        <p className="materialText">
          Clique para abrir ou baixar a lista de materiais do {item.ano}.
        </p>
        </a>
        ))}
      </div>
    </section>
);

export default MateriaisSection;
